import React from 'react';

const RelatedDiagrams = ({
  relatedRef,
  related,
  relLoading,
  relError,
  allDiagrams,
  selectedDiagramId,
  setSelectedDiagramId,
  linking,
  linkError,
  onLinkDiagram,
  onUnlinkDiagram,
  onNavigate,
  theme,
  styles,
  entryId,
  canLink = false
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const smallBtn = { ...styles.btn, padding: '4px 8px', fontSize: 12 };

  return (
    <div ref={relatedRef} style={{ marginTop: 12, paddingTop: 4, borderTop: `1px dashed ${theme.toolbar.buttonBorder}` }}>
      <button
        onClick={() => setExpanded(e => !e)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: theme.toolbar.text,
          fontWeight: 700,
          fontSize: 14,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '0 0 8px 0',
          width: '100%',
          textAlign: 'left'
        }}
      >
        <span>{expanded ? '▲' : '▼'}</span>
        <span>Связанные диаграммы ({(related || []).length})</span>
      </button>

      {expanded && (
        <div>
          {canLink && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
              <select
                value={selectedDiagramId}
                onChange={(e) => setSelectedDiagramId(e.target.value)}
                style={{
                  flex: 1,
                  padding: 8,
                  borderRadius: 6,
                  border: `1px solid ${theme.toolbar.buttonBorder}`,
                  background: theme.toolbar.buttonBackground,
                  color: theme.toolbar.text
                }}
              >
                <option value="">— выбрать диаграмму —</option>
                {allDiagrams
                  .filter(d => !related.some(r => r.id === d.id))
                  .map(d => (
                    <option key={d.id} value={d.id}>{d.meta?.name || d.id}</option>
                  ))}
              </select>
              <button
                style={smallBtn}
                disabled={!selectedDiagramId || linking}
                onClick={() => onLinkDiagram(entryId, selectedDiagramId)}
              >
                Привязать
              </button>
            </div>
          )}

          {linkError && <div style={{ color: '#ff6b6b', marginBottom: 8 }}>Ошибка: {linkError}</div>}
          {relLoading && <div style={{ color: theme.toolbar.text, opacity: 0.8 }}>Загрузка…</div>}
          {relError && <div style={{ color: '#ff6b6b' }}>Ошибка: {relError}</div>}

          {!relLoading && !relError && (
            related.length === 0 ? (
              <div style={{ color: theme.toolbar.text, opacity: 0.7 }}>Нет связанных диаграмм</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {related.map((d) => (
                  <div
                    key={d.id || d.doc_id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      border: `1px solid ${theme.toolbar.buttonBorder}`,
                      background: theme.toolbar.buttonBackground,
                      borderRadius: 6,
                      padding: '8px 10px'
                    }}
                  >
                    <div>
                      <div style={{ color: theme.toolbar.text, fontWeight: 600 }}>
                        {d.meta?.name || d.id || d.doc_id}
                      </div>
                      <div style={{ fontSize: 12, opacity: 0.75 }}>
                        Обновлено: {d.meta?.updatedAt ? new Date(d.meta.updatedAt).toLocaleString() : '—'}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        style={smallBtn}
                        onClick={() => onNavigate(`/editor/${encodeURIComponent(d.id || d.doc_id)}?type=${d.meta?.type || 'uml'}`)}
                      >
                        Открыть
                      </button>
                      {canLink && (
                        <button
                          style={{ ...smallBtn, background: theme.name === 'dark' ? '#2a1f1f' : '#fff1f1' }}
                          onClick={() => onUnlinkDiagram(entryId, d.id || d.doc_id)}
                        >
                          Отвязать
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default RelatedDiagrams;
